/**
 * Tabella Ant Design dei risultati (variante BiAskSuccess: columns + data).
 * Sempre mostrata. null/undefined -> "—". Zero righe -> empty state.
 * Dati "sporchi" (es. cliente "None None" o valori inattesi): mostrati come sono,
 * senza crashare (render difensivo di qualsiasi unknown).
 */

import { Table } from 'antd'
import type { TableProps } from 'antd'

type Row = Record<string, unknown>

interface ResultTableProps {
  columns: string[]
  data: Row[]
}

/** Rende un valore qualsiasi in stringa, senza crashare. */
function renderCell(value: unknown): string {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

function ResultTable({ columns, data }: ResultTableProps) {
  // Le chiavi reali dei record possono differire da `columns` se c'erano nomi
  // duplicati (lo shaping li suffissa: totale, totale_2). Allineiamo per indice.
  const recordKeys = data.length > 0 ? Object.keys(data[0]) : columns

  const antColumns: TableProps<Row>['columns'] = columns.map((title, i) => ({
    title,
    dataIndex: recordKeys[i] ?? title,
    key: String(i),
    render: (value: unknown) => renderCell(value),
  }))

  return (
    <Table<Row>
      columns={antColumns}
      dataSource={data}
      rowKey={(_, index) => String(index)}
      size="small"
      scroll={{ x: true }}
      pagination={{ pageSize: 20, hideOnSinglePage: true }}
      locale={{ emptyText: 'Nessun risultato' }}
    />
  )
}

export default ResultTable
